import React, { useEffect, useRef } from "react";
import { Modal } from "react-bootstrap";
import ModalCloseButton from "../../../../components/modal/components/ModalCloseButton";
import {
  BarcodeScanner,
  CameraEnhancer,
} from "dynamsoft-barcode-reader-bundle";

interface I_ERROR_MODAL {
  onPressClose: () => void;
  onScanBarcode: (barcode: string) => void;
}

const ScannerModal: React.FC<I_ERROR_MODAL> = ({
  onPressClose,
  onScanBarcode,
}) => {
  const scannerRef = useRef<BarcodeScanner | null>(null);
  const cameraEnhancerRef = useRef<CameraEnhancer | null>(null);
  const DynamSoftKey =
    "DLS2eyJoYW5kc2hha2VDb2RlIjoiMTAzNjM4Mjc2LVRYbFhaV0pRY205cSIsIm1haW5TZXJ2ZXJVUkwiOiJodHRwczovL21kbHMuZHluYW1zb2Z0b25saW5lLmNvbSIsIm9yZ2FuaXphdGlvbklEIjoiMTAzNjM4Mjc2IiwiY2hlY2tDb2RlIjotNTIyOTc4ODA1fQ==";

  useEffect(() => {
    let isMounted = true;

    const initScanner = async () => {
      // Close and unmount previous scanner if it exists

      if (scannerRef.current) {
        await scannerRef.current.dispose();
        scannerRef.current = null;
      }

      const config = {
        license: DynamSoftKey,
        container: ".barcode-scanner-view",
        uiPath:
          "https://cdn.jsdelivr.net/npm/dynamsoft-barcode-reader-bundle@10.5.3000/dist/",
        engineResourcePaths: {
          rootDirectory:
            "https://cdn.jsdelivr.net/npm/dynamsoft-barcode-reader-bundle@10.5.3000/dist/",
        },
      };

      const scanner = new BarcodeScanner(config);
      scannerRef.current = scanner;
      if (cameraEnhancerRef.current) {
        cameraEnhancerRef.current.open();
      }
      try {
        const result = await scanner.launch();
        if (isMounted && result?.barcodeResults?.[0]?.text) {
          onScanBarcode(result.barcodeResults[0].text);
        }
      } catch (err) {
        console.error("Scanner launch error:", err);
      }
    };

    initScanner();

    return () => {
      isMounted = false;
      if (scannerRef.current) {
        scannerRef.current.dispose();
        cameraEnhancerRef.current?.dispose();
        scannerRef.current = null;
        cameraEnhancerRef.current = null;
      }
    };
  }, []);

  return (
    <Modal show backdrop onBackdropClick={onPressClose}>
      <ModalCloseButton onPressCross={onPressClose} />
      <Modal.Body className="error-modal-wrapper">
        <div
          style={{ width: "100%", marginBottom: 50, height: 300 }}
          className="barcode-scanner-view"
        ></div>
      </Modal.Body>
    </Modal>
  );
};

export default ScannerModal;
